import { Types } from "../../constants/index.js";
import SubField from "../builders/SubField.js";
export default SubField({
  objectType: Types.deviceType,
  baseAttrName: 'options',
  baseAttrField: 'options',
  field: 'imagine/subGroupName',
  creatable: true,
  editable: true,
  displayName: 'Sub-Group Name',
  valueType: 'string'
});